'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formClassName = formClassName;
exports.getFormId = getFormId;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Outside wrapper for an editable field.
function formClassName(className, isActive, status) {
  var cssClasses = {
    active: isActive,
    'has-error': status === 'error',
    'has-success': status === 'success',
    'has-warning': status === 'warning',
    'has-feedback': status
  };
  return (0, _classnames2.default)('editable-field', cssClasses, className);
}
function getFormId(_ref) {
  var id = _ref.id;

  return id + '-group';
}
// Editable formGroup wrapper.
function FormGroup(props) {
  var children = props.children,
      className = props.className,
      isActive = props.isActive,
      id = props.id,
      name = props.name,
      onSubmit = props.onSubmit,
      isRequired = props.isRequired,
      isSaving = props.isSaving,
      savingTxt = props.savingTxt,
      status = props.status;


  var formStyle = formClassName(className, isActive, status);
  return _react2.default.createElement(
    'form',
    { className: formStyle, id: getFormId(props), onSubmit: onSubmit },
    _react2.default.createElement(
      'label',
      { className: 'control-label', htmlFor: id },
      _react2.default.createElement(
        'strong',
        null,
        name,
        isRequired ? '*' : false
      ),
      children,
      isSaving && _react2.default.createElement(
        'span',
        { className: 'field-saving small mono' },
        savingTxt
      )
    )
  );
}

FormGroup.propTypes = {
  children: _propTypes2.default.node.isRequired, // The input field.
  className: _propTypes2.default.string, // Optional className given to container.
  // errorMessage: PropTypes.string,
  id: _propTypes2.default.string.isRequired, // Used for id html prop on form element.
  isActive: _propTypes2.default.bool.isRequired, // Used in css classes.
  name: _propTypes2.default.string.isRequired, // The label.
  onSubmit: _propTypes2.default.func, // Capture the submit event. Value partially applied.
  isRequired: _propTypes2.default.bool, // Little asterisk next to field name.
  isSaving: _propTypes2.default.bool, // Show saving text.
  savingTxt: _propTypes2.default.string.isRequired, // Text to display when saving.
  status: _propTypes2.default.string // Status string sent from redux-field.
};

FormGroup.defaultProps = {
  savingTxt: 'Saving...',
  wrapClass: 'form-horizontal'
};

exports.default = FormGroup;


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/Editable/FieldGroupEl.js
// module id = 672
// module chunks = 0